import { useCallback, useContext, useState } from 'react';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import css from './Event.module.scss';
import { deleteEventFunction } from '../../helpers';
import UserContext from '../../../../../../common/utils/getContext';
import classNames from 'classnames';
import T from '../../../../../../common/components/T';
import EventModal from '../../../../../../widgets/eventModal/EventModal';
import { getEventDuration } from '../../../../../../common/utils/utils';
import { LangContext } from '../../../../../../common/decorators/Language';

export default function Event(props) {
    const { translation } = useContext(LangContext);
    const { key, event, showCreateEventModal, setReloadData, setEvents } = props;
    const { userToken, lang } = useContext(UserContext);

    // подробиці івенту
    const [showEvent, setShowEvent] = useState(false);

    // стан для кнопок редагувати/видалити
    const [eventEditModal, showEventEditModal] = useState(false);

    // видалення івенту
    const deleteEvent = useCallback(
        (event) => deleteEventFunction(event, setReloadData, setEvents, userToken, lang),
        [setReloadData, userToken, lang]
    );
    return (
        <>
            <div key={key} className={css.eventItem} onClick={() => setShowEvent(event)}>
                <div className={css.eventItemContent}>
                    <p className={css.eventTime}>
                        {getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).allDay ? (
                            <span>
                                <T textName='allDayEvent' defaultStr='Весь день' page='/office' />
                            </span>
                        ) : (
                            <>
                                <span>{getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).date}</span>
                                <span>{getEventDuration(event, translation, { format: 'HH:mm', returnObj: true }).duration}</span>
                            </>
                        )}
                    </p>
                    <p className={css.eventDescription}>{event.description}</p>
                </div>
                {event.can_edit ? (
                    <div
                        onClick={(e) => {
                            e.stopPropagation();
                            showEventEditModal((state) => (state?.id === event?.id ? false : event));
                        }}
                        className={css.eventIcon}
                    >
                        {svgSprite('dots', { className: css.eventSvg })}
                        {event?.id === eventEditModal?.id ? (
                            <div className={css.eventEdit}>
                                <div
                                    onClick={() =>
                                        showCreateEventModal({ ...event, date: new Date(event?.event_date), id_edit: true })
                                    }
                                    className={css.eventEditItem}
                                >
                                    <p className={css.eventEditItemText}>
                                        <T textName='edit' defaultStr='Редактировать' />
                                    </p>
                                </div>
                                <div onClick={() => deleteEvent(event)} className={css.eventEditItem}>
                                    <p className={classNames(css.eventEditItemText, css.eventEditItemTextDelete)}>
                                        <T textName='delete' defaultStr='Удалить' />
                                    </p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
            {showEvent ? (
                <EventModal
                    event={event}
                    closeHandler={() => setShowEvent(false)}
                    deleteEvent={deleteEvent}
                    showCreateEventModal={showCreateEventModal}
                />
            ) : null}
        </>
    );
}
